export enum Severity {
  Success = 'success',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}
